"use client"
import { useState } from "react";
import BFLTabs from "@repo/shared-ui/BFLTabs";
import BFLTable from "@repo/shared-ui/BFLTable";
import { buildCorporateActionTable } from "./utility";
import { ICorporateActionsContent, ITableOption } from "./types";
import { ICorporateActions } from "../../interfaces/CorporateAction.interface";
import { componentNameConstants, dlElementConstants, dlEventConstants } from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

const CorporateAction = ({ content, data, companyName }: { content: ICorporateActionsContent, data: ICorporateActions, companyName: string }) => {
    const tabList = Object.values(content.tabList);
    const [selectedTab, setSelectedTab] = useState<string>(tabList[0]?.value ?? "");
    const [showTable, setShowTable] = useState(true);

    // Build tab options from content columns
    const tabOptions: Record<string, ITableOption> = {};
    Object.entries(content.columns).forEach(([tabKey, columnGroup]) => {
        tabOptions[tabKey] = {
            columnOrder: Object.values(columnGroup),
        };
    });

    // Build table data for all tabs
    const tabData = buildCorporateActionTable(tabOptions, data as any);

    const handleOnClick = () => {
        setShowTable(!showTable);
    }
    
    const handleOnClickCT = (val: string) => {
        setSelectedTab(val);
        const data = {
            section_title: componentNameConstants.CORPORATE_ACTIONS,
            component: componentNameConstants.CORPORATE_ACTIONS,
            event: dlEventConstants.CLICK,
            event_type: dlEventConstants.BUTTON_CLICK,
            element: dlElementConstants.CORPORATE_ACTIONS_CTA_CLICK,
            cta_text: val,
        };

        const cleverTapObj = {
            EVENT_NAME: "trading_mall_details_submitted",
            EP_SECTION: componentNameConstants.CORPORATE_ACTIONS,
            EP_CTA: val
        };
        dataLayer("", data, cleverTapObj);
    };
    return (

        <div className={`flex flex-col py-[12px] px-[16px] gap-[16px] max-sm:p-0`}>

            <div className="flex items-center justify-between" >
                <h2 className="max-sm:text-[18px] text-[20px] text-gray-900 font-medium cursor-pointer" >{companyName} {content?.postHeaderText}</h2>
                {
                    showTable ?
                        <i className="icomoon size-[16px] before:content-['\e910'] text-[#1A1A1A]  cursor-pointer max-sm:hidden" onClick={handleOnClick} /> :
                        <i className="icomoon size-[16px] before:content-['\e909'] text-[#1A1A1A]  cursor-pointer max-sm:hidden" onClick={handleOnClick} />
                }
            </div>
            {
                showTable &&
                <>
                    <BFLTabs tabs={tabList} selectedTab={selectedTab} color="text-bfl-blue" onTabChange={handleOnClickCT} tabClassName="mr-3 md:mr-4 pb-[1px]" gapClassName="md:pb-[14px]" />
                    {
                        Object.keys(tabData)?.map((el) => (
                            <BFLTable key={el} columns={tabData?.[el]?.columns} rows={tabData?.[el]?.rows} tableWrapperClassName={selectedTab === el ? "" : "hidden"} emptyStateClassName={selectedTab === el ? "" : "hidden"} />
                        ))
                    }
                </>
            }
        </div>
    )
}

export default CorporateAction;